import React, { Component } from 'react';

import { assembleNickname } from "utils/Helper.js";

const UserContext = React.createContext({});

class UserProvider extends Component {
  // Context state
  
  state = {
    theme: window.localStorage.getItem('theme') || "light",
    language_abbreviation: window.localStorage.getItem('language_abbreviation') || "en-US",
    user_info: {
      //theme: window.localStorage.getItem('theme') || "light",
      //language_abbreviation: window.localStorage.getItem('language_abbreviation') || "en-US",
      organizations: [],
      resident_locations: [],
      favorite_categories: [],
      events: [], // for event admins
      chats: [],
      friends: [],
      admins: []
    }
  }

  // Method to update state
  setUserInfo = user_info => {
    // add nickname
    user_info.nickname = assembleNickname(user_info);
    this.setState({ user_info });
  }
  
  setTheme = theme => {
    window.localStorage.setItem('theme',theme);
    this.setState({theme});
  }
  
  setLanguage = language_abbreviation => {
    window.localStorage.setItem('language_abbreviation',language_abbreviation);
    this.setState({language_abbreviation});
  }

  render() {
    const { children } = this.props;
    const { user_info, theme, language_abbreviation } = this.state;
    const { setUserInfo, setTheme, setLanguage } = this;

    return (
      <UserContext.Provider
        value={{
          user_info,
          setUserInfo,
          theme,
          setTheme,
          language_abbreviation,
          setLanguage
        }}
      >
        {children}
      </UserContext.Provider>
    );
  }
}

export default UserContext;

export { UserProvider };